import React, { FC, ReactNode, ReactNodeArray } from 'react';
import { Container } from 'styled-bootstrap-grid';
import { Heading } from '@ch/common/components/heading';
import { container } from '@ch/common/const/container';
import { Route } from '@ch/common/const/route';
import { ColorProps } from '../../const/color';
import { HeaderStyled, HeaderInner as Inner, HeaderBlock as Block } from './header.styled';
import { Link as HeaderLink } from '../link';
import { HeaderTextStyled } from '@ch/form/src/layout.styled';

const Header: FC<{
  children?: ReactNode | ReactNodeArray;
  $color?: ColorProps;
  $bgColor?: string;
  appName?: string;
  logo: string;
  companyName?: string;
  showCompanyName: boolean;
}> = ({
  children,
  companyName,
  showCompanyName,
  appName = 'Adverse Event Intake',
  logo,
  $color = 'primary',
  $bgColor = '#1E2846',
}) => {
  return (
    <HeaderStyled {...{ $color, $bgColor }}>
      <Container {...container}>
        <Inner>
          <Block>
            <HeaderLink href={Route.HOME}>
              {showCompanyName ? (
                <Heading
                  {...{
                    $size: 'h2',
                    $fontWeight: 400,
                    $color: $color === 'primary' ? 'primary' : 'black',
                  }}
                >
                  {companyName}
                </Heading>
              ) : (
                <img src={logo} height={35} />
              )}
            </HeaderLink>
            <HeaderTextStyled $color={'primary' ? 'primary' : 'black'}>
              <Heading
                {...{
                  $size: 'h5',
                  $fontWeight: 700,
                  $m: [0],
                  $color: $color === 'primary' ? 'primary' : 'black',
                }}
              >
                {appName}
              </Heading>
            </HeaderTextStyled>
          </Block>
          <Block>{children}</Block>
        </Inner>
      </Container>
    </HeaderStyled>
  );
};

export default Header;
